import React, { useState } from 'react';
import s from './Navbar.module.css';
import { useMediaQuery } from 'react-responsive';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faClose } from '@fortawesome/free-solid-svg-icons';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

export default function Navbar({data}) {

    const [isNavOpen, setIsNavOpen] = useState(false);

    const query900 = useMediaQuery({ query: '(max-width: 900px)' });

    if(!data.length){
        return (
            <header className={s.header}>
                <LoadingSpinner/>
            </header>
        )
    }

    if(!query900) return (
        <header className={s.header}>
        <nav>
            <ul>
                {
                    data.slice(0, Math.ceil(data.length / 2)).map((d, i)=>{
                        return <li key={i} onClick={()=>{window.scrollTo(0, document.getElementById(d.parametros.slice(5)).offsetTop-120);}}>{d.nombre}</li>
                    })
                }
                <li onClick={()=>{window.scrollTo(0, document.getElementById("Hero").offsetTop);}}><img src={`http://www.peuma-ig.com.ar/admin/${data[0]?.imagen}`} alt="Peuma Logo"/></li>
                {
                    data.slice(Math.ceil(data.length / 2), data.length).map((d, i)=>{
                        return <li key={i} onClick={()=>{window.scrollTo(0, document.getElementById(d.parametros.slice(5)).offsetTop-120);}}>{d.nombre}</li>
                    })
                }
                <li onClick={()=>{window.scrollTo(0, document.getElementById("Contacto").offsetTop-120);}}>Contacto</li>
            </ul>
        </nav>
        </header>
    )

    if(query900) return (
        <header className={s.header} style={{height: isNavOpen ? "300px" : "120px"}}>
        <nav>
            <div className={s.responsiveNav}>
                <img src={`http://www.peuma-ig.com.ar/admin/${data[0]?.imagen}`} alt="Peuma Logo" onClick={()=>{window.scrollTo(0, document.getElementById("Hero").offsetTop);}}></img>
                {
                    isNavOpen ? 
                    <FontAwesomeIcon className={s.menuIcon} icon={faClose} color="#707070" onClick={()=>{setIsNavOpen(false);}}/> :
                    <FontAwesomeIcon className={s.menuIcon} icon={faBars} color="#707070" onClick={()=>{setIsNavOpen(true);}}/>
                }
            </div>
            <ul>
                <li onClick={()=>{window.scrollTo(0, document.getElementById("Hero").offsetTop); setIsNavOpen(false);}}>Propuesta</li>
                <li onClick={()=>{window.scrollTo(0, document.getElementById("Servicios").offsetTop-120); setIsNavOpen(false);}}>Servicios</li>
                <li onClick={()=>{window.scrollTo(0, document.getElementById("CasosDeExito").offsetTop-120); setIsNavOpen(false);}}>Casos de éxito</li>
                <li onClick={()=>{window.scrollTo(0, document.getElementById("Contacto").offsetTop-120); setIsNavOpen(false);}}>Contacto</li>
            </ul>
        </nav>
        </header>
    )
}
